import { PayPalScriptProvider, PayPalButtons, FUNDING } from "@paypal/react-paypal-js";
import { message } from "antd";

type Props = {
  styles: Object,
  createOrder: Function,
  onApprove: Function,
  payPalClientId: String,
  currency: String,
  country: String,
  accountSupportedPaymentTypes?: Array<String>,
  tipComponent?: any,
}

const PayPalCheckout = (props: Props) => {
  const {styles, createOrder, onApprove, payPalClientId, currency, country, accountSupportedPaymentTypes, tipComponent } = props;
  const env = process.env.REACT_APP_ENV;
  let initialOptions = {};
  if (env === "Production") {
    initialOptions = {
    "client-id": payPalClientId,
    currency: currency,
    intent: "capture",
    "enable-funding": "venmo",
    "disable-funding": "card,paylater",
  };
  } else if (env !== "Production") {
    initialOptions = {
    "client-id": payPalClientId,
    currency: currency,
    intent: "capture",
    "enable-funding": "venmo",
    "disable-funding": "card,paylater",
    "buyer-country": country,
  };
  }

  let fundingSource = undefined;
  if (accountSupportedPaymentTypes) {
    const hasVenmo = accountSupportedPaymentTypes.includes("VENMO");
    const hasPaypal = accountSupportedPaymentTypes.includes("PAYPAL_WALLET");
    if (hasVenmo && !hasPaypal) {
      fundingSource = FUNDING.VENMO;
    } else if (hasPaypal && !hasVenmo) {
      fundingSource = FUNDING.PAYPAL;
    }
  }

  return (
    <>
      {tipComponent && (
        <div style={{ marginBottom: '16px' }}>{tipComponent}</div>
      )}
      <div style={{ width: '200px' }}>
        <PayPalScriptProvider options={initialOptions}>
          <PayPalButtons
            fundingSource={fundingSource}
            style={styles}
            createOrder={createOrder}
            onApprove={onApprove}
            onError={() =>
              message.error(
                "Please perform the required action and/or try again later."
              )
            }
          />
        </PayPalScriptProvider>
      </div>
    </>
  );
};

export default PayPalCheckout;
